import {useState} from "preact/compat";
import {useEffect} from "preact/hooks";

export const useDefaultPicker = (props) => {
    // Destructured props
    const {
        handleSelectedValue,
        handleErrors,
    } = props;

    // State to control the dropdown display state
    const [isOpen, setIsOpen] = useState(null);

    // Method to handle the dropdown button action
    const handleOpen = (id) => {
        setIsOpen(prevState => id !== prevState ? id : null);
    }

    // Method to handle when an option has been selected
    const handleChange = data => {
        handleSelectedValue({
            data
        });

        handleErrors(false);
    }

    // Unchecks any previously selected value in case of region change
    // TODO: we might have to come back here to improve the flick situation
    useEffect(() => {
        handleChange({
            id: undefined,
            label: undefined,
            stockQty: undefined
        })
    }, [isOpen]);

    return {
        isOpen,
        handleOpen,
        handleChange,
    }
};
